import {useEffect, useState} from "react";

import {PlantService} from "plant/service";
import {plant_view_adapter} from "plant/model";

import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider/ErrorProvider";

import {PlantChip, PlantDataFields} from "plant/presentational";
import {PlantForm} from "plant/presentational/form";
import {
    SectionCardHeaderAction,
    SubSectionCardHeader,
} from "base/ui/section/components";
import {DeleteItemDialog} from "base/delete/components";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const ViewOrUpdatePlantDataContent = ({plantationId, plant, allowEdit = true}) => {
    const navigate = useNavigateWithReload();
    const {handleErrors, clearErrors} = useErrors();

    const [mode, setMode] = useState("view");
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

    useEffect(() => {
        clearErrors();
    }, []);

    const handleDelete = () => {
        PlantService.delete(plant.id).then(() => {
            navigate("", true);
        });
    };

    const handleFormSubmit = plant => {
        PlantService.update(plant_view_adapter(plant))
            .then(updatedPlant => {
                console.log(updatedPlant);
                setMode("view");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    const actions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                setMode("edit");
            }}
        />,
        <SectionCardHeaderAction
            key="delete"
            name="delete"
            text="Remover"
            icon={<DeleteIcon color="error" />}
            onClick={() => {
                setIsDeleteDialogOpen(true);
            }}
        />,
    ];

    const getComponent = mode => {
        if (mode === "view") {
            return <PlantDataFields plant={plant} />;
        }
        if (mode === "edit") {
            return (
                <PlantForm
                    plantationId={plantationId}
                    plant={plant}
                    onSubmit={handleFormSubmit}
                    onCancel={() => {
                        setMode("view");
                    }}
                />
            );
        }
    };

    return (
        <Card sx={{border: 1, borderRadius: 2, borderColor: "grey.300"}} elevation={0}>
            <SubSectionCardHeader
                titleTags={<PlantChip element={plant} />}
                actions={allowEdit ? actions : null}
            />
            <CardContent>{getComponent(mode)}</CardContent>
            <DeleteItemDialog
                isDialogOpen={isDeleteDialogOpen}
                setIsDialogOpen={setIsDeleteDialogOpen}
                onDelete={handleDelete}
            />
        </Card>
    );
};

export default ViewOrUpdatePlantDataContent;
